/**
 * Geo-detection service using ipapi.co (free, no key required).
 * Returns: { country, countryCode, city, lang, currency }
 * Maps location to suggested language and currency automatically.
 */

const COUNTRY_LANG = {
  PL: 'pl',
  FR: 'fr', BE: 'fr', MC: 'fr', LU: 'fr',
  DE: 'de', AT: 'de', CH: 'de', LI: 'de',
  IT: 'it', SM: 'it', VA: 'it',
};

const COUNTRY_CURRENCY = {
  PL: 'PLN',
  CH: 'CHF', LI: 'CHF',
};

const EU_EUR = ['FR','DE','IT','AT','BE','NL','ES','PT','IE','FI','GR','SK','SI','LV','LT','EE','MT','CY','LU','MC','SM','VA'];

export async function detectGeo() {
  const cached = localStorage.getItem('sac_geo');
  if (cached) {
    try { return JSON.parse(cached); } catch { /* ignore */ }
  }
  try {
    const res = await fetch('https://ipapi.co/json/', { signal: AbortSignal.timeout(4000) });
    const d = await res.json();
    const code = (d.country_code || '').toUpperCase();
    const lang = COUNTRY_LANG[code] || 'en';
    let currency = 'EUR';
    if (COUNTRY_CURRENCY[code]) currency = COUNTRY_CURRENCY[code];
    else if (!EU_EUR.includes(code)) currency = 'EUR'; // default EUR outside EU
    const geo = {
      countryCode: code,
      country: d.country_name || '',
      city: d.city || '',
      region: d.region || '',
      lang,
      currency,
    };
    localStorage.setItem('sac_geo', JSON.stringify(geo));
    return geo;
  } catch {
    return null;
  }
}

export function clearGeoCache() {
  localStorage.removeItem('sac_geo');
}
